import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Box,
    Typography,
    RadioGroup,
    FormControlLabel,
    Radio,
    Button,
    Alert,
} from "@mui/material";
import { Localized } from "@fluent/react";
import { BlobMeta } from "../../documents/attachementsSlice";

interface BlobPickerDialogProps {
    open: boolean;
    onClose: () => void;
    onApply?: () => void;
    blobs: BlobMeta[];
    selectedBlobId: string | null;
    onChangeSelectedBlob: (blobId: string) => void;
}

export const BlobPickerDialog: React.FC<BlobPickerDialogProps> = ({
    open,
    onClose,
    onApply,
    blobs,
    selectedBlobId,
    onChangeSelectedBlob,
}) => {
    const hasBlobs = !!blobs?.length;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChangeSelectedBlob(e.target.value);
    };

    const handleApply = () => {
        if (onApply) {
            onApply();
        }
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Select the file that AI should search in the context of this requirement:</DialogTitle>

            <DialogContent dividers>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    {hasBlobs && (
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 1,
                            }}
                        >
                            <RadioGroup
                                value={selectedBlobId ?? ""}
                                onChange={handleChange}
                            >
                                {blobs?.map((b) => (
                                    <FormControlLabel
                                        key={b.blobId}
                                        value={b.blobId}
                                        control={<Radio size="small" />}
                                        label={
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                {b.fileMeta.fileName}
                                            </Typography>
                                        }
                                    />
                                ))}
                            </RadioGroup>
                        </Box>
                    )}

                    {!hasBlobs && (
                        <Alert severity="warning">
                            <Localized id="">
                                <span>
                                    No attachments available for this document
                                </span>
                            </Localized>
                        </Alert>
                    )}
                </Box>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button
                    onClick={handleApply}
                    disabled={!selectedBlobId || !hasBlobs}
                    variant="contained"
                >
                    Select
                </Button>
            </DialogActions>
        </Dialog>
    );
};
